import React, { Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import moment from "moment";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Popconfirm } from "antd";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
import useSearchHook from "hooks/useSearch.hook";
import { getSearch, remove } from "actions/chargers/station/actions";
import Filters from "./filters";
import { EMPTY_DASH } from "../../../../constants";

const FILTERS_KEY = "stationList";

const ChargerStationsList = ({
                               getSearch,
                               remove,
                               ...rest
                             }) => {
  const {
    loading,
    list,
  } = rest;

  const {
    page,
    size,
    filters,
    sort,
    handleSearch,
    handleReset,
    handlePageChange,
    handleSortedChange,
    handlePageSizeChange
  } = useSearchHook(getSearch, {
    size: 20,
    sort: "lastUpdatedAt,desc",
    name: FILTERS_KEY
  });

  const handleDelete = (ev, id) => {
    ev.preventDefault();
    remove(id, () => {
      getSearch(page, size, sort, filters);
    });
  };

  const getColumns = () => [
    {
      Header: "QR",
      accessor: "qr",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Link to={`/chargers/stations/list/${original.qr}`}>
          {original.qr}
        </Link>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Owners",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (original.owners && Array.isArray(original.owners) ? <div>
        {original.owners.map(item => (
          <div key={item.id}><b>({item.percent}%)</b> {item.fullname}</div>
        ))}
      </div> : EMPTY_DASH),
      width: 220,
    },
    {
      Header: "Name",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (Array.isArray(original.translations) && original.translations.length ? original.translations[0].destinationName : EMPTY_DASH),
      width: 220,
      sortable: false,
    },
    {
      Header: "Type",
      accessor: "type",
    },
    {
      Header: "Country",
      accessor: "country",
    },
    {
      Header: "Network Mode",
      accessor: "networkMode",
    },
    {
      Header: "Connection Level",
      accessor: "connectionLvl",
    },
    {
      Header: "PB Count",
      accessor: "powerBanksCount",
    },
    {
      Header: "PB Slots",
      accessor: "slotsCount",
    },

    {
      Header: "Working Hours",
      accessor: "workingHours",
    },
    {
      Header: "Discount",
      accessor: "discount",
    },
    {
      Header: "Last Update Date",
      accessor: "lastUpdateAt",
      Cell: ({ original }) => (original.lastUpdateAt ? moment(original.lastUpdateAt)
        .format("HH:mm YYYY-MM-DD") : EMPTY_DASH),
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Fragment>
          <Link to={`/chargers/stations/edit/${original.id}`} className="btn btn-sm mx-2 btn-warning">
            <FontAwesomeIcon icon={faPencilAlt}/>
          </Link>
          <Popconfirm
            title="Are you sure?"
            onConfirm={(ev) => handleDelete(ev, original.id)}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm btn-danger mx-2">
              <FontAwesomeIcon icon={faTimes}/>
            </button>
          </Popconfirm>
        </Fragment>
      ),
    }
  ];

  return (
    <div className="w-100 p-2">
      <div className="filters">
        <Filters
          name={FILTERS_KEY}
          activeFilters={filters}
          totalCount={list.total_count || 0}
          handleSearch={handleSearch}
          handleReset={handleReset}
        />
      </div>

      <ReactTable
        data={list.content || []}
        headerClassName="table-header"
        columns={getColumns()}
        pageSizeOptions={[10, 20, 50, 100]}
        resizable
        className="-striped -highlight table-header-padding"
        loading={loading}
        filterable={false}
        defaultFilterMethod={filterCaseInsensitive}
        style={{
          height: "calc(100vh - 140px)"
        }}
        manual={true}
        pages={list.total_pages}
        page={page}
        pageSize={size}
        onSortedChange={handleSortedChange}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  loading: state.chargerStation.loading,
  list: state.chargerStation.list,
});

const mapStateToDispatch = dispatch => ({
  getSearch: bindActionCreators(getSearch, dispatch),
  remove: bindActionCreators(remove, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ChargerStationsList);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/stations/index.js